import fillStoreKey from './middlewares/fillStoreKey'

module.exports = {
  name: '門市資料',
  model: 'stores',
  middlewares: [fillStoreKey],
  // ui: {
  //   list: {
  //     columns: [
  //       // { key: 'account' },
  //       { key: 'name' },
  //       { key: 'organize' },
  //     ],
  //   },
  //   editor: {
  //     groups: [
  //       {
  //         name: '',
  //         rows: [
  //           // [{ key: 'account' }],
  //           [{ key: 'name' }],
  //           [{ key: 'organize' }],
  //           [{ key: 'key' }],
  //         ],
  //       },
  //     ],
  //   },
  // },
}



// WEBPACK FOOTER //
// ./src/views/stores.js